<div *ngIf="!showAtBottom" class="page-action-container mb-10">
  <ng-container *ngTemplateOutlet="buttonContainer"></ng-container>
</div>
<sigv-bottom-panel
  [(visible)]="showAtBottom"
  [threshold]="230"
  [contentHeight]="contentHeight"
  [styleClass]="isMenuVisible ? 'offset-for-sidemenu' : ''"
>
  <div *ngIf="showAtBottom" class="p-text-center pv-15 cfc-wrapper-bg-gray">
    <ng-container *ngTemplateOutlet="buttonContainer"></ng-container>
  </div>
</sigv-bottom-panel>
<ng-template #buttonContainer>
  <div class="button-group-container">
    <ng-content></ng-content>
  </div>
</ng-template>
